import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Tenant header for multi-tenant backend tracing/routing.
    if (!config.headers['X-Store-Id']) {
      try {
        const rawStore = localStorage.getItem('selectedStore');
        if (rawStore) {
          const store = JSON.parse(rawStore);
          if (store?.id) {
            config.headers['X-Store-Id'] = String(store.id);
          }
        }
      } catch {
        // Ignore malformed localStorage data; request still proceeds.
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const payload = error?.response?.data;
    const errorCode = payload?.error || payload?.detail?.error;
    const errorMessage = payload?.message || payload?.detail?.message || payload?.detail;

    if (errorCode === 'limit_reached' || errorCode === 'trial_expired') {
      window.dispatchEvent(new CustomEvent('aiviora:upgrade-trigger', {
        detail: {
          code: errorCode,
          title: errorCode === 'limit_reached' ? 'Limit reached' : 'Trial expired',
          message: errorCode === 'limit_reached'
            ? 'Upgrade your plan to continue'
            : 'Trial expired - upgrade to continue',
          rawMessage: typeof errorMessage === 'string' ? errorMessage : '',
        },
      }));
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedStore');
      localStorage.removeItem('is_demo');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.replace('/login?session_expired=true');
      }
    }

    // Show toast for network failures and 5xx server errors.
    // 4xx errors (validation, auth) are handled inline by each component.
    const isNetworkError = !error.response;
    const isServerError = error.response?.status >= 500;
    if (isNetworkError || isServerError) {
      const message = isNetworkError
        ? 'Network error — check your connection'
        : `Server error (${error.response.status}) — please try again`;
      window.dispatchEvent(new CustomEvent('aiviora:api-error', { detail: { message } }));
    }

    return Promise.reject(error);
  }
);

export default api;
